import axios from "axios";

const app = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false
});
// Add interceptor
app.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('keyCloakaccesstokenData');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);
export default app;